export default "https://cdn-static.gokick.com/assets/f1ffb082694ccd599c5c343ec9cae3a0a74687d7/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";